module.exports = __webpack_public_path__ + "img/mortimer_b2.c215b121.jpg";